export const localSet = (name:any, value:any) => localStorage.setItem(name,value)
export const sessionSet = (name:any, value:any) => sessionStorage.setItem(name,value)

export const localGet = (name:any) => localStorage.getItem(name)
export const sessionGet = (name:any) => sessionStorage.getItem(name)

export const localDel = (name:any) => localStorage.removeItem(name)
export const sessionDel = (name:any) => sessionStorage.removeItem(name)